// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"764":"45db9c1c","921":"93074aa2"}[chunkId] + ".chunk.css";
};